import { DistributorProfile } from "creso-core/types";

export function DistributorProfileSummary({
  distributorProfile,
}: {
  distributorProfile: DistributorProfile;
}) {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-sm font-semibold">
        Generated by {distributorProfile?.name}
      </span>
      <span className="text-xs text-muted-foreground">
        {`ARN ${distributorProfile?.arn_code}`} |{" "}
        {distributorProfile?.phone_number}
      </span>
      <span className="text-xs text-muted-foreground">
        AMFI registered Mutual Fund Distributor
      </span>
    </div>
  );
}
